export default [
  { label: '(AA) Aguas Andinas', value: 'AA' },
  { label: '(AC) Aguas Cordillera', value: 'AC' },
  { label: '(AM) Aguas Manquehue', value: 'AM' },
  // { label: '(AA-AC) Aguas Andinas - Aguas Cordillera', value: 'AA-AC' },
  // { label: '(AA-AM) Aguas Andinas - Aguas Manquehue', value: 'AA-AM' },
  // { label: '(AM-AC) Aguas Manquehue - Aguas Cordillera', value: 'AM-AC' },
  // { label: '(AA-AC-AM) Aguas Andinas - Aguas Cordillera - Aguas Manquehue', value: 'AA-AC-AM' },
];
